export default __webpack_public_path__ + "static/media/placeholder-produtos-zero-grau.447fca88.png";